// extracted by mini-css-extract-plugin
module.exports = {"container":"SellerSignIn_container__2a9tu","ssImage":"SellerSignIn_ssImage__3kThS","rotate":"SellerSignIn_rotate__lEnM5","content":"SellerSignIn_content__2ULoD"};